import styled from 'styled-components';
export const Container = styled.div`
    display: flex;
    width: 100%;
    min-height: calc(100% + 6rem);
    padding: 2rem;
    background-color: #f6f6f6;
    align-items: center;
    gap: 2rem;
    flex-direction: column;
    .disabled{
      pointer-events: none;
      opacity: 0.7;
    }
    .column{
      display: flex;
      width: 100%;
      align-items: center;
      gap: 1rem;
      font-weight: 400;
    }
`;
export const BoxSelect = styled.div`
  display: flex;
  width: 90%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
  .box--{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 1rem;
    .line-{
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      justify-content: space-between;
      .date{
        width: 10rem;
        border: 1px solid #1D86FF;
        background-color: transparent;
      }
    }
  }
  .list-{
    width: 20rem;
  }
  
`;
export const BtnSearch = styled.button`
    outline: none;
    border: none;
    display: flex;
    width: 3rem;
    height: 2.5rem;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    color: #ffffff;
    background-color: #1D86FF;
    font-size: 1.5rem;

    .loader{
      display: flex;
      border: 2px solid #ffffff;
      border-radius: 50%;
      border-top: 2px solid #1d83e2;
      width: 2rem;
      height: 2rem;
      animation: spin 1.5s linear infinite;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
`;
export const Content = styled.div`
  display: flex;
  width: 100%;
  gap: 1.2rem;
  flex-direction: column;
  .user-filter{
    border-radius: 4px;
    max-width: 450px;
    background: #ffffff;
    border:solid 1px #e8e8e8;
  }
`;
export const Title = styled.div`
  position: relative;
  max-width:700px;
  text-align: center;
  padding: 1rem;
  border-radius: 4px;
  font-size: 1.3rem;
  font-weight: bolder;
  background-color: #ffffff;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  border-left: 3px solid #1D86FF;
  > span {
    position: absolute;
    display: flex;
    width: 5rem;
    height: 5rem;
    top: -35px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    font-size: 1.5rem;
    color: #ffff;
    background-color: #1D86FF;
    box-shadow: rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px
  }
  > div {
    margin-left: 5rem;
  }
`;